import React from 'react'
import classnames from 'classnames'

import './DataTable.scss'

const DataTableRow = ({ className, children }) => {
  return (
    <div className={classnames('datatable__row', className)}>{children}</div>
  )
}

export default DataTableRow
